// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"79dd3148","152":"b52a7fe4","366":"d247a8ff","475":"2631e5ad","823":"07ddd1d3"}[chunkId] + ".chunk.js";
};